export const countElementsWithinMaxLines = (elements: HTMLElement[], maxLines: number): number => {
  if (elements.length === 0) {
    return 0;
  }

  let lines = 1;
  let currentTop = elements[0].offsetTop;

  for (let index = 0; index < elements.length; index += 1) {
    const top = elements[index].offsetTop;
    if (top !== currentTop) {
      lines += 1;
      currentTop = top;
    }
    if (lines > maxLines) {
      return index;
    }
  }

  return elements.length;
};

export interface ChipOverflowResult {
  visibleCount: number;
  hiddenCount: number;
}

export const resolveVisibleChipCount = (
  chipElements: HTMLElement[],
  overflowElement: HTMLElement | null,
  maxLines = 2,
): ChipOverflowResult => {
  const total = chipElements.length;
  const fittingCount = countElementsWithinMaxLines(chipElements, maxLines);

  if (fittingCount >= total) {
    return { visibleCount: total, hiddenCount: 0 };
  }

  let visibleCount = fittingCount;

  if (!overflowElement) {
    visibleCount = Math.max(0, visibleCount - 1);
    return { visibleCount, hiddenCount: total - visibleCount };
  }

  const lastChipTop = chipElements[visibleCount - 1]?.offsetTop ?? 0;
  if (overflowElement.offsetTop > lastChipTop) {
    visibleCount = Math.max(0, visibleCount - 1);
  }

  return { visibleCount, hiddenCount: total - visibleCount };
};
